export const FETCH_USER_HISTORY_LIST_STARTED = 'FETCH/USER/HISTORY/LIST/STARTED';
export const FETCH_USER_HISTORY_LIST_SUCCESS = 'FETCH/USER/HISTORY/LIST/SUCCESS';
export const FETCH_USER_HISTORY_LIST_FAILURE = 'FETCH/USER/HISTORY/LIST/FAILURE';
export const SET_USER_HISTORY_FILTER = 'SET/USER/HISTORY/FILTER'